import { Injectable } from '@angular/core';

function getWindow(): any {
  return window;
}

@Injectable()
export class WindowRefService {
  get nativeWindow(): any {
    return getWindow();
  }

  getHref():string{
    let w: Window;
    w = getWindow();
    return w.location.href;
  }
}
